import { render, staticRenderFns } from "./product_add.vue?vue&type=template&id=c331278e&scoped=true&"
import script from "./product_add.vue?vue&type=script&lang=js&"
export * from "./product_add.vue?vue&type=script&lang=js&"
import style0 from "./product_add.vue?vue&type=style&index=0&id=c331278e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c331278e",
  null
  
)

export default component.exports